module.exports = __webpack_public_path__ + "dcos.logo.7093a.png";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/dcos/logo/dcos.logo.png
// module id = 4130
// module chunks = 0